module.exports = __webpack_public_path__ + "static/media/pingtai.9634bf03.png";